import { FC } from 'react';

import { EditDocumentGeneratorName } from '@components/TableUpdateNameCell/EditDocumentGeneratorName';
import { DocumentGeneratorTemplate } from '@app/types/document-generator-template';
import styles from './index.module.scss';

interface TableDocumentGeneratorCellProps {
  value: string;
  id: DocumentGeneratorTemplate['id'];
  onSuccess: () => void;
  onUpdate: (id: number, data: Partial<any>) => Promise<any>;
  onClickCell?: () => void;
}

/**
 * @param value - The table cell value
 * @param id - Active demand id
 * @param onSuccess - Function which is called after successful demand update
 * @param onUpdate - Function which is called after successful demand update
 * @param onClickCell - Function called when the cell is clicked
 * @description a modal for demand table cell
 */

const TableUpdateNameCell: FC<TableDocumentGeneratorCellProps> = ({
  value,
  id,
  onSuccess,
  onUpdate,
  onClickCell,
}) => {
  return (
    <div
      className={styles.documentGeneratorTemplateCellWrapper}
      onClick={onClickCell}
    >
      <img alt="document" src="/icons/document.svg" />
      <EditDocumentGeneratorName
        onSuccess={onSuccess}
        onUpdate={onUpdate}
        size="small"
        value={value}
        documentGeneratorId={id}
        editOnHover
      />
    </div>
  );
};

export { TableUpdateNameCell };
